import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      minHeight: '100vh',
      '& *:focus': {
        outline: 'none !important'
      }
    },
    form: {
      marginBottom: theme.spacing(2)
    }
  });
